<template>
  <div class="relative flex flex-col w-full rounded lg:inline-block">
    <button
    @click="pressDropdown()"
      class="flex flex-row items-center justify-between py-2 text-black rounded lg:text-white lg:px-4 focus:outline-none group"
    >
      <span :class="['pr-1', prependVariant('group-hover', selectedStyle), showDropdown ? selectedStyle:unselectedStyle]">{{name}} </span>
      <font-awesome-icon v-if="items.length != 0" :icon="showDropdown ? 'chevron-up' : 'chevron-down'" :class="['fa-xs lg:block hidden', showDropdown ? selectedStyle:unselectedStyle]"/>
      <font-awesome-icon v-if="items.length != 0" :icon="showDropdown ? 'chevron-down' : 'chevron-right'" :class="['fa-xs lg:hidden block', showDropdown ? selectedStyle:unselectedStyle]"/>
    </button>

    <ul :class="['lg:absolute right-0 text-white pt-1', showDropdown ? 'block' : 'hidden']">
      <li v-for="(dropdownItem, index) in items" v-bind:key="index+'dropdown-item-key'"
          :class="['bg-gray-200 block whitespace-no-wrap', unselectedStyle, {'rounded-t': (index == 0), 'rounded-b': (index == items.length-1)}]"
      >
        <sub-dropdown-component
          @click="clicked()"
          :category="name"
          :subCategory="dropdownItem.name"
          :items="dropdownItem.subItems"
          :right="right"
        />
      </li>
    </ul>
  </div>
</template>

<script>

import { busEvents, bus } from '../eventBus';
import SubDropdownComponent from './SubDropdown.vue';

export default {
  name: 'dropdown',
  data() {
    return {
      showDropdown: false,
      selectedStyle: 'text-black',
      unselectedStyle: 'text-gray-700',
    };
  },
  components: {
    SubDropdownComponent,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    right: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    prependVariant(variant, elemClass) {
      const elemClassTrimmed = ` ${elemClass.trim()}`;
      return elemClassTrimmed.split(' ').join(` ${variant}:`);
    },
    pressDropdown() {
      bus.$emit(busEvents.CLOSE_ALL_OTHER_DROPDOWNS, this.name);
      this.showDropdown = !this.showDropdown;

      // Redirects to
      if (this.items.length == 0) {
        this.$router.push(
          { path: 'Items', query: { category: this.name } },
        );
      }
    },
    clicked() {
      this.showDropdown = false;
      console.log('HII');
    },
  },
  mounted() {
    bus.$on(busEvents.CLOSE_ALL_OTHER_DROPDOWNS, (dropdownName) => {
      if (this.name != dropdownName) {
        this.showDropdown = false;
      }
    });
    this.$el.addEventListener('click', (event) => {
      event.stopPropagation();
      bus.$emit(busEvents.CLOSE_ALL_OTHER_DROPDOWNS, this.name);
      bus.$emit(busEvents.CLOSE_ALL_OTHER_SUB_DROPDOWNS, '');
    });
  },
};
</script>

<style scoped>

</style>
